<div
  [attr.data-prime-id]="primeId"
  [id]="containerId"
  [ngClass]="dynamicClass"
  class="Overlay"
>
  <!-- Content supplied by vendor -->
</div>
